import React from "react";
import "./Loading.css";
import {searchPayment} from "../extras/Actions";

export default class Loading extends React.Component{
    render() {
        return (
            <div className="loading">
                <div className="message-1">
                    Por favor espera
                </div>
                <div className="message-2 d-none">
                    <p>
                        Tu tarjeta solicitó una verificación de dos pasos. <br/>
                        Por favor realiza este paso y presiona el boton de abajo.
                    </p>
                    <button onClick={searchPayment}>
                        Validar pago
                    </button>
                </div>
            </div>
        );
    }
}